import { getLocale } from '@/shared/i18n'

/** Даты и числа — только через Intl. Библиотек дат в проекте нет. */
export function formatDate(value: string | Date): string {
  return new Intl.DateTimeFormat(getLocale(), { dateStyle: 'medium' }).format(new Date(value))
}

export function formatDateTime(value: string | Date): string {
  return new Intl.DateTimeFormat(getLocale(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value))
}

/** Только время — «09:12»: для событий сегодняшнего дня, где дата уже понятна из контекста. */
export function formatTime(value: string | Date): string {
  return new Intl.DateTimeFormat(getLocale(), { timeStyle: 'short' }).format(new Date(value))
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(getLocale(), options).format(value)
}

export function formatMoney(value: number, currency = 'RUB'): string {
  return new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(value)
}

/**
 * Сумма, пришедшая строкой десятичного числа (деньги бэка — строки, без округления на клиенте):
 * два знака после запятой, без символа валюты — валюту такие ручки не называют.
 */
export function formatAmount(value: string): string {
  return formatNumber(Number(value), { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** Месяц `ГГГГ-ММ` — «сентябрь 2026 г.». */
export function formatMonth(value: string): string {
  return new Intl.DateTimeFormat(getLocale(), { month: 'long', year: 'numeric' }).format(
    new Date(`${value}-01T00:00:00`),
  )
}
